<div style="margin-left:30px;margin-bottom:20px;">


    <form 
    (ngSubmit)="onSubmitMassUpdate()" 
    novalidate
    [formGroup]="massUpdateForm" 
    style="margin-top:5px;">

    <div class="row mt-5 ml-4" style="width:98%">
        <div class="row" style="width:100%">
            <div class="col-2" style="padding-top:20px;">
                <input class="form-check-input" type="checkbox" value="" id="updateCompany" formControlName="updateCompany" (change)="evalMassUpdateReadyForSubmit()" >
                <label class="form-check-label" for="updateCompany" style="margin-left:5px;font-size: larger;">
                    Assign New Company
                </label>
            </div>

            <div class="col-9">
                <mat-form-field appearance="fill" style="width:50%;color:gray">
                    <mat-label>Company:</mat-label>
                    <mat-select  [typeaheadDebounceInterval]="500" formControlName="companyId"  (selectionChange)="evalMassUpdateReadyForSubmit()">
                        <mat-option value="NONE">Select Company</mat-option>
                        <mat-option *ngFor="let company of this.parkerStateService.companyList" [value]="company.companyId" >
                        {{company.companyName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row" style="width:100%">
            <div class="col-2" style="padding-top:20px;">
                <input class="form-check-input" type="checkbox" value="" id="updateRate" formControlName="updateRate"  (change)="evalMassUpdateReadyForSubmit()">
                <label class="form-check-label" for="updateRate" style="margin-left:5px;font-size: larger;">
                    Assign New Rate
                </label>
            </div>

            <div class="col-9">
                <mat-form-field appearance="fill" style="width:50%;">
                    <mat-label>Rate:</mat-label>
                    <mat-select  [typeaheadDebounceInterval]="500" formControlName="rateNumber"  (selectionChange)="evalMassUpdateReadyForSubmit()">
                        <mat-option value="NONE">Select Rate</mat-option>
                        <mat-option *ngFor="let rate of this.marketRateList" [value]="rate.rateNumber" >
                        {{(rate.rateType)}} {{rate.activeRate | currency }} - {{rate.description}}-  {{GetTextForLotRateUsageMetrics(rate.rateNumber, rate.rateType)}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row" style="width:100%">
            <div class="col-2" style="padding-top:20px;">
                <input class="form-check-input" type="checkbox" value="" id="updateParkerPayType" formControlName="updateParkerPayType"  (change)="evalMassUpdateReadyForSubmit()">
                <label class="form-check-label" for="updateParkerPayType" style="margin-left:5px;font-size: larger;">
                    Change Parker Pay Type Method
                </label>
            </div>

            <div class="col-9">
                <mat-form-field appearance="fill" style="width:50%;">
                    <mat-label>Parker Pay Type:</mat-label>
                    <mat-select  [typeaheadDebounceInterval]="500" formControlName="parkerPayType"  (selectionChange)="evalMassUpdateReadyForSubmit()">
                        <mat-option value="ALL">Select Parker Pay Type</mat-option>
                        <mat-option value="Company">Company</mat-option>
                        <mat-option value="Parker">Parker</mat-option>
                        </mat-select>
                    </mat-form-field>
            </div>
        </div>

        <div class="row" style="width:100%">
            <div class="col-2" style="padding-top:20px;">
                <input class="form-check-input" type="checkbox" value="" id="updateInvoiceDeliveryDate" formControlName="updateInvoiceDeliveryDate" (change)="evalMassUpdateReadyForSubmit()">
                <label class="form-check-label" for="updateInvoiceDeliveryDate" style="margin-left:5px;font-size: larger;">
                    Change Invoice Delivery Method
                </label>
            </div>

            <div class="col-9">
                <mat-form-field appearance="fill" style="width:50%;">
                    <mat-label>Invoice Delivery Method:</mat-label>
                    <mat-select  [typeaheadDebounceInterval]="500" formControlName="invoiceDeliveryMethod"  (selectionChange)="evalMassUpdateReadyForSubmit()">
                        <mat-option value="ALL">Select Invoice Delivery Method</mat-option>
                        <mat-option value="Email">Email</mat-option>
                        <mat-option value="Print">Print</mat-option>
                        </mat-select>
                    </mat-form-field>
            </div>
        </div>

        <div class="row" style="width:100%">
            <div class="col-2" style="padding-top:20px;">
                <input class="form-check-input" type="checkbox" value="" id="updateTermDate" formControlName="updateTermDate" (change)="evalMassUpdateReadyForSubmit()">
                <label class="form-check-label" for="updateInvoiceDeliveryDate" style="margin-left:5px;font-size: larger;">
                    End Date
                </label>
            </div>

            <div class="col-9">
                <mat-form-field appearance="fill" style="width:50%">
                    <mat-label>Assign End Date</mat-label>
                            <input matInput [matDatepicker]="termDate" formControlName="termDate" id="termDate" DateToCurrentYear autocomplete="chrome-off" (dateChange)="evalMassUpdateReadyForSubmit()">
                            <mat-datepicker-toggle matIconSuffix [for]="termDate"></mat-datepicker-toggle>
                            <mat-datepicker #termDate></mat-datepicker>
                            <!-- <mat-error *ngIf="parkerNewParkerForm.get('startDate')!.hasError('required')">The start date is required</mat-error> -->
                    </mat-form-field>
            </div>
        </div>

        <div class="row" style="width:95%;margin-top:3px;">
            <div class="col-12">
                
                <button type="submit" class="btn btn-primary mt-3 ace-blue" 
                style="margin-left:0px;width:200px;margin-bottom:5px;" [disabled]="updateButtonDisabled">Update Parker(s)</button><br />
                <span style="font-size:16px; margin-top:5px;">Checkboxes must be enabled to select criteria and process update.</span>
            </div>
            
        </div>

    </div>

    </form>

</div>


